import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 12a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1l0 -3","key":"svg-0"}],["path",{"d":"M10 11v-2a2 2 0 1 1 4 0v2","key":"svg-1"}],["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12","key":"svg-2"}]]

const IconLockSquare = createReactComponent('outline', 'lock-square', 'LockSquare', __iconNode);

export default IconLockSquare;